{
  "lastUpdatedAt": "2026-07-29T11:13:03.775Z",
  "lastFetchAttemptAt": "2026-07-29T11:13:03.775Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}